/**
   * @ngdoc directive
   * @name adjust.directive:loading
   * @scope
   * @restrict A
   *
   * @description
   * General loading directive
   *
   * @param {Function} loading loading state
   */
function loading() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    controller: 'LoadingController',
    controllerAs: 'vm',
    bindToController: {
      loading: '=',
      color: '@'
    }
  };
}

/**
   * @ngdoc directive
   * @name adjust.directive:loadingSpinner
   * @scope
   * @restrict A
   *
   * @description
   * Child loading spinner
   *
   */
function loadingSpinner($animate) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    require: '^loading',
    link: function(scope, element, attrs, parentCtrl) {

      parentCtrl.onChange(handleChange);

      element.addClass('loader-overlay animate');
      angular.element(element).parent().addClass('loading-on-progress');

      if (parentCtrl.color) {
        element.addClass(parentCtrl.color);
      }

      /**
       * @ngdoc method
       * @name handleChange
       * @methodOf adjust.directive:loadingSpinner
       *
       * @description
       * Change the loader spinner class when state is changed
       *
       * @param {boolean} loading loading state
       */
      function handleChange(loading) {

        if (loading) {
          $animate.addClass(element, 'loader-overlay-show');
        } else {
          $animate.removeClass(element, 'loader-overlay-show');
          angular.element(element).parent().removeClass('loading-on-progress');
        }

      }

    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:LoadingController
   *
   * @description
   * All the functionality of the {@link adjust.directive:loading loading} directive
   *
   */
function LoadingController($element, $compile, $scope, Loading) {
  'ngInject';
  var vm = this;

  var _instance = Loading.register();
  var _changeCallback;

  vm.onChange = onChange;

  _init();

  $scope.$watch('vm.loading', _change);
  $element.on('$destroy', _handleDestroy);

  /**
   * @ngdoc method
   * @name _init
   * @methodOf adjust.controller:LoadingController
   *
   * @description
   * Render loader spinner and trigger the instance
   * @private
   */
  function _init() {

    var spinner = angular.element('<span id="loader-' + _instance + '" loading-spinner></span>');

    $element.append(spinner);
    $compile(spinner)($scope);

    $element.addClass('relative');

  }

  /**
   * @ngdoc method
   * @name onChange
   * @methodOf adjust.controller:LoadingController
   *
   * @description
   * Register on change callback
   *
   * @param {Function} c on change callback
   */
  function onChange(c) {

    _changeCallback = c;

  }

  /**
   * @ngdoc method
   * @name _change
   * @methodOf adjust.controller:LoadingController
   *
   * @description
   * Set appropriate class name depending on loading state
   *
   * @param {boolean} loading loading state
   * @private
   */
  function _change(loading) {

    if (!angular.isFunction(_changeCallback)) { return; }

    _changeCallback.call(null, loading);

  }

  /**
   * @ngdoc method
   * @name _handleDestroy
   * @methodOf adjust.controller:LoadingController
   *
   * @description
   * Handle destroy event
   * - set loading state to false
   * - clear all callbacks related to loading event
   *
   * @private
   */
  function _handleDestroy() {

    _changeCallback = null;

  }
}


export { LoadingController, loadingSpinner, loading };
